import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="relative">
        {/* Outer ring with gradient */}
        <div className="w-16 h-16 rounded-full border-4 border-transparent border-t-blue-500 border-r-purple-500 animate-spin-fast"></div>

        {/* Inner dot with pulse animation */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse-fast"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
